import { render, staticRenderFns } from "./ErroresSQL.vue?vue&type=template&id=554d1eaf&"
import script from "./ErroresSQL.vue?vue&type=script&lang=js&"
export * from "./ErroresSQL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports